// settings
export const TOGGLE_SETTINGS = 'TOGGLE_SETTINGS';
export const TOGGLE_LOADING_SCREEN = 'TOGGLE_LOADING_SCREEN';
export const TOGGLE_SIDE_MENU = 'TOGGLE_SIDE_MENU';
export const SET_STAGE_DIMENSIONS = 'SET_STAGE_DIMENSIONS';
export const SET_MOLECULE_CENTER_Y_FROM_BOTTOM_OF_CANVAS =
  'SET_MOLECULE_CENTER_Y_FROM_BOTTOM_OF_CANVAS';
export const SET_INTERVALS_TO_REACH_MOLECULE_CENTER =
  'SET_INTERVALS_TO_REACH_MOLECULE_CENTER';
export const SET_OSCILLATION_DIRECTION = 'SET_OSCILLATION_DIRECTION';
